import React, {useEffect,useContext,useRef} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import Portal from "../Helpers/Portal";
import CKEditor from "../Helpers/CKEditor";
import AceEditor from "../Helpers/AceEditor";
import {ComponentContext} from "../../contexts";
import axios from "../../utils/axios";
import DataExporter from "../Helpers/DataExporter";

function Textarea(props) {
  const store = useLocalObservable(() => ({
    fullscreen:false,
    wrapper_height:100,
    ace_inited:false,
    laste_height_set:0,
    ace_last_length:0,
  }));
  const compStore=useContext(ComponentContext);
  let _ckeRef = useRef(null);
  let _taRef = useRef(null);
  let _aceRef = useRef(null);
  const data = compStore.data;

  useEffect(() => {
    // mount
    if (typeof data.value === 'undefined') {
      data.value = '';
    }
    // if (this.props.options.force) {
    //   for (let i in this.props.options.force) {
    //     this.props.values[i] = this.props.options.force[i];
    //   }
    // }

    return () => {
      prepareAce();
      // unmount
    }
  }, []);

  const prepareAce = () => {
    if (data.mode === "html") {
      if (!data.ace_mode) {
        data.ace_mode = "html";
      }
    }
  };

  const isMode = (mode) => {
    if (data.mode === mode) {
      return true
    }

    if (!mode && !data.mode) {
      return true;
    }

    return false;
  };
  const isBg = (mode) => {
    if (data.bg === mode) {
      return true;
    }

    if (!mode && !data.bg) {
      return true;
    }

    return false;
  };

  const getBgClass=()=> {
    if (isBg('dark')) {
      return 'bg-b2';
    } else {
      return 'bg-w1';
    }
  };

  const renderAceLang = () => {
    const langs = [
      'html', 'json', 'yaml', 'php', 'javascript', 'css'
    ];

    const opts = langs.map((item) => {
      return (
        <option key={item} value={item}>{item}</option>
      )
    });
    return (
      <span className="select small mright20">
          <select value={data.ace_mode} onChange={(e) => {
            data.ace_mode = e.target.value;
          }}>{opts}</select>
        </span>
    )
  };

  const typografText = () => {
    axios.post("/sysapi/typograf", {text: data.value}).then((axiosData) => {
      data.value = axiosData.data.answer;
    });
  };

  const renderSwitch = () => {
      return (
        <div>
          <div className="solid1-bottom bo-w3 mleft5 mright5"></div>
          <div className=" fs12 padd5">
            <div className="up12 splice">
              <div className="cell s-auto">
                {true?<span>
                  <span className={`dib ttu mright20 pointer ${isMode('wysiwyg')?'w3':'b4'}`} onClick={()=>{ data.mode='wysiwyg'; }}>wysiwyg</span>
                  <span className={`dib ttu mright20 pointer ${isMode(false)?'w3':'b4'}`} onClick={()=>{ data.mode='';  }}>plain</span>
                  <span className={`dib ttu mright20 pointer ${isMode('html')?'w3':'b4'}`} onClick={()=>{ data.mode='html'; data.ace_mode='html'; }}>&lt;/&gt;</span>
                  {data.mode==="html"?renderAceLang():null}
                </span>:null}

                <span style={{ lineHeight:'16px', padding:'0 2px'}}  className={`dib ttu mright20 mdi lh1 mdi-fullscreen pointer ${store.fullscreen?'bg-b1 w1':' b4'}`} onClick={()=>{ store.fullscreen=!store.fullscreen; }}></span>
                {isMode('wysiwyg')?<span className={`dib mright20 pointer hpadd5 italic ${isBg('dark')?'w1 bg-b1':'b1 bg-w3'}`} onClick={()=>{ data.bg=(data.bg=='dark'?'':'dark'); }}>a</span>:null}
              </div>
              <div className="cell s-shrink">
                <span className="mdi mdi-format-textdirection-l-to-r lh10 b4 pointer" onClick={()=>{ typografText(); }}></span>
              </div>
            </div>
          </div>

        </div>
      )
    }

  const applyHeight = (aceAfterrender) => {
    if (!data.mode || data.mode === "plaintext") {
      runInAction(()=>{
        store.ace_last_length=0;
        store.ace_inited=false;
      });
      if (_taRef.current) {
        let newHeight = _taRef.current.scrollHeight;
        if (newHeight < 100) {
          newHeight = 100;
        }
        if (store.wrapper_height !== newHeight) {
          runInAction(()=>{
            store.wrapper_height = newHeight;
          });
        }
      }
    }

    if (data.mode === "wysiwyg") {
      runInAction(()=>{
        store.ace_last_length=0;
        store.ace_inited=false;
      });
      if (_ckeRef.current && _ckeRef.current.editorInstance) {
        let newHeight = _ckeRef.current.editorInstance.element.$.scrollHeight;
        if (newHeight < 100) {
          newHeight = 100;
        }
        if (store.wrapper_height !== newHeight) {
          runInAction(() => {
            store.wrapper_height = newHeight;
          });
        }
      }
    }

    if (data.mode === "html") {
      if (_aceRef.current) {
        if (aceAfterrender && store.ace_inited) {
          return false;
        }
        runInAction(() => {
          store.ace_inited = true;
        });

        var newHeight =
          (_aceRef.current._editor.getSession().getScreenLength() - 0)
          * _aceRef.current._editor.renderer.lineHeight
          + 24;

        if (newHeight < 100) {
          newHeight = 100;
        }

        if (store.wrapper_height !== newHeight) {
          runInAction(() => {
            store.wrapper_height = newHeight;
            store.laste_height_set = newHeight;
            store.ace_last_length = _aceRef.current._editor.getSession().getScreenLength();
          });
          _aceRef.current._editor.resize();
        }
      }
    }
  };
  const renderEditor = () => {
    if (!data.mode || data.mode === "plaintext") {
      let style = {minHeight: '100px', maxHeight: '100%', maxWidth: '100%', border:'none'};

      return (
        <div className="h100">
          <div className="ofh" style={{height: 0}}>
            <textarea ref={(ref) => {
              _taRef.current=ref;
              applyHeight();
            }} style={style} className="w100" readOnly={true} value={data.value}/>
          </div>
          <textarea style={style} className="w100 h100" value={data.value} onChange={(e) => {
            data.value = e.target.value;
          }}/>
        </div>
      )
    };




    if (data.mode === "wysiwyg") {
      return (
        <CKEditor
          ref={(ref) => {
            _ckeRef.current=ref;
          }}
          activeClass="p10"
          inline={true}
          content={data.value}
          events={{
            "change": (evt) => {
              data.value = evt.editor.getData();
              applyHeight();
            },
            "instanceReady": (evt) => {
              applyHeight();
            }
          }}
        />
      )
    }
    if (data.mode === "html") {
      return (
        <AceEditor
          ref={(ref) => {
            _aceRef.current=ref;
          }}
          fullScreen={store.fullscreen}
          mode={data.ace_mode ? data.ace_mode : 'html'}
          theme="merbivore_soft"
          value={data.value}
          width="100%"
          height="100%"
          fontSize={14}
          showLineNumbers={false}
          onChange={(newValue) => {
            data.value = newValue;
            applyHeight();
          }}
          name="UNIQUE_ID_OF_DIV"
          editorProps={{$blockScrolling: Infinity}}
          afterRender={() => {
            if (!store.ace_inited) {
              applyHeight(true);
            }
          }}
          setOptions={{
            enableBasicAutocompletion: true,
            enableEmmet: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            fontFamily: "Monaco, monospace"
          }}
        />
      )
    }
  };


  if(store.fullscreen) {
    return (
      <Portal>
        <div className={`pf pa-tl w100 h100 bg-w2`} style={{zIndex:1500,padding:'80px 30px 0 30px'}}>
          <div className={getBgClass()}>
            <div style={{height:'calc(100vh - 110px)'}}>
              {renderEditor()}
            </div>
          </div>
          {renderSwitch()}
        </div>
      </Portal>
    )
  }
  return (
    <div className={`bg-w1`}>
      <div className={getBgClass()}>
        <div style={{height:store.fullscreen?'calc(100vh - 110px)':store.wrapper_height}}>
          {renderEditor()}
        </div>
      </div>
      {renderSwitch()}
      <DataExporter exportIndex={compStore.options.exportIndex} rawValue={compStore.options.exportIndex?true:false} />
    </div>
  )

};

Textarea.defaultProps = {};

Textarea.propTypes = {}

export default observer(Textarea);
